import { IPreInit } from './core/interfaces/App/IPreInit'
import preInit from './core/services/init/index.tsx'

preInit()
  .then(async (initParams: IPreInit) => {
    await import('APIManager')
    await import('EntityManager')
    await import('MainState')
    await import('Utils')
    await import('@auravant/icons')
    await import('@auravant/ui-kit')
    await import('@auravant/core')
    await import('@auravant/components')
    // await import('Maps')

    const module = await import('./bootstrap')
    module.initPlatform(initParams)
  })
